const es = {
    breadcrumbs: {
        title: 'Portales de Empleo',
        description: 'Accede a estas empresas para ver las ofertas de empleo activas'
    },
    label: {
        go_to_portal: 'Ir al portal',
    },
}

const employmentPortalsTranslations = {
    es,
    es_MX: es,
    es_CL: es,
    es_PE: es,
    en: {
        breadcrumbs: {
            title: 'Employment Portals',
            description: 'Visit these companies to see active job openings'
        },
        label: {
            go_to_portal: 'Go to portal',
        },
    },
}

export default employmentPortalsTranslations
